<template>
  <div class="p-privacy container">
    <h2>
      隱私權政策
    </h2>
    <br>
    <p>
      本集團以旗下之關係企業所設網站作為媒介，以提供其產品、服務、或活動之相關資訊，包括但不限於本網站提供其所舉辦之各項新聞、活動及所販售之廣告商品等之相關訊息；當您進入瀏覽或使用本網站時，即表示並視為您已閱讀、瞭解並同意接受本會員服務條款暨個人資料蒐集告知之規定。如您對於本內容感到無法接受，或您所屬的國家或地區與本規範有所衝突時，為了避免不必要的困擾，您有權離開或隨時停止瀏覽本網站。
      <br>
      <br>
      本公司及本集團有權於任何時間修改或變更本會員服務條款暨個人資料蒐集告知之內容，並公布於本網站且不另行通知，建議您隨時注意條款修改或變更。您於任何修改或變更後繼續使用本服務，視同您已閱讀，瞭解並同意接受該等修改或變更。如果您不同意本會員服務條款暨個人資料蒐集告知之內容，應立即停止使用本服務。
      <br>
      <br>
      一、遵守會員規範及法令規定<br>
      申請人了解其於 (下稱本網站)提供個人資料進行註冊後，即成為本站會員，得使用本公司所提供之會員相關服務，並同意接受本規範及所有注意事項之拘束，並遵守相關法律規定。
      <br>
      <br>
      特別提醒您，若您未提供必要個人資料，您將無法成為我們的會員，享受本公司所提供之各項會員服務；若您為提供完證之正確資訊，您可能無法參與本公司所舉辦各項活動或獲得最新資訊。申請人未滿二十歲，應於加入會員前，將本規範請法定代理人(家長)或監護人閱讀，並得到其同意。會員申請註冊後，視為本同意書已獲其法定代理人(家長)或監護人閱讀及同意。
      <br>
      <br>
      二、會員的註冊義務
      <br>
      為了能使用本服務，您同意以下事項：
      <br>
      依本服務註冊表之提示提供會員本人正確、最新的資料，且不得以第三人之名義註冊為會員。每位會員僅能註冊登錄一個帳號，不可重覆註冊登錄。若會員提供任何錯誤或不實的資料、或未按指示提供資料、或欠缺必要之資料、或有重覆註冊帳號等情事時，本網站有權不經事先通知，逕行暫停或終止會員的帳號，並拒絕會員使用本服務之全部或部份。
      <br>
      <br>
      三、網站連結
      <br>
      本公司在網站或所有服務相關網頁上所提供之所有連結，可能連結到其他個人、本集團旗下關係企業以外之公司或組織之網站，提供該等連結之目的，僅係為便利會員自行搜集或取得資訊，本公司對於被連結之該等個人、公司或組織之網站上所提供之產品、服務或資訊，不擔保其品質、真實性、完整性、即時性或可信度，該等個人、本集團以外公司或組織亦不因此而當然與本集團有任何僱佣、委任、代理、合夥或其他類似之關係。
      <br>
      <br>
      四、會員帳號、密碼及安全性
      <br>
      完成本服務的登記程序之後，會員將取得一個特定之密碼及會員帳號，維持密碼及帳號之機密安全，是會員的責任。任何依照規定方法輸入會員帳號及密碼與登入資料一致時，無論是否由本人親自輸入，均將推定為會員本人所使用，利用該密碼及帳號所進行的一切行動，會員本人應負完全責任。
      <br>
      會員同意以下事項：
      <br>
      1. 會員的資料遭到盜用或有其他任何安全問題發生時，會員將立即通知本網站客服。
      <br>
      2. 每次連線完畢，均結束會員的帳號使用。
      <br>
      3. 會員的帳號、密碼及會員權益均僅供會員個人使用及享有，不得轉借、轉讓他人或與他人合用。
      <br>
      4. 帳號及密碼遭盜用、不當使用或其他本網站無法辯識是否為本人親自使用之情況時，對此所致之損害，除證明係因可歸責於之事由所致，將不負任何責任。
      <br>
      5. 本網站若知悉會員之帳號密碼確係遭他人冒用時，將立即暫停該帳號之使用(含該帳號所生交易之處理)。
      <br>
      <br>
      五、兒童及青少年之保護為確保兒童及青少年使用網路的安全，並避免隱私權受到侵犯，家長（或監護人）應盡到下列義務：未滿十二歲之兒童使用本服務時時，應全程在旁陪伴，十二歲以上未滿十八歲之青少年使用本服務前亦應斟酌是否給予同意。
      <br>
      <br>
      六、會員規範之修改為因應社會環境及法令規定的變遷與科技的進步，促進個人資料之合理使用等，本網站及本集團有權於任何時間修改或變更本條款暨權利聲明之內容，並公佈於本網站且不另行通知，建議您隨時注意條款修改或變更。您於任何修改或變更後繼續使用本服務，視同您已閱讀、了解並同意接受該等修改或變更。如果您不同意本條款暨權利聲明之內容，應立即停止使用本服務。
      <br>
      <br>
      因此對於任何會員或第三人所可能產生之困擾、不便或損害，本公司、本網站均不負任何責任。如會員不同意修改的內容，請停止使用本服務。如會員繼續使用本服務，則視為會員已同意並接受本規範該等增訂或修改內容之拘束。
      <br>
      <br>
      七、會員對之授權若您無合法權利得授權他人使用、修改、重製、公開播送、改作、散布、發行、公開發表某資料，並將前述權利轉授權第三人，請勿擅自將該資料上載、傳送、輸入或提供予本網站。您所上載、傳送、輸入或提供予本網站之任何資料，其權利仍為您或您的授權人所有；但任何資料一經您上載、傳送、輸入或提供予本網站時，即表示您同意：
      <br>
      1. 由本網站儲存或管理該資料，並由本網站公開刊登、使用於本網站的相關系統網路上，包括但不限於本網站合作的第三人網站上。
      <br>
      2. 授權本網站及其關係企業可以基於公益或為宣傳、推廣或經營本網站及本服務之目的，進行使用、修改、重製、公開播送、改作、散布、發行、公開發表、公開傳輸、公開上映、翻譯該等資料，並得在此範圍內將前述權利轉授權他人。您並保證本網站及其關係企業使用、修改、重製、公開播送、改作、散布、發行、公開發表、公開傳輸、公開上映、翻譯、轉授權該等資料，不致侵害任何第三人之智慧財產權，否則應對本網站及其關係企業負損害賠償責任。
      <br>
      <br>
      八、使用者的守法義務及承諾您承諾絕不為任何非法目的或以任何非法方式使用本服務，並承諾遵守中華民國相關法規及一切使用網際網路之國際慣例。您若係中華民國以外之使用者，並同意遵守所屬國家或地域之法令。您同意並保證不得利用本服務從事侵害他人權益或違法之行為，包括但不限於：
      <br>
      1. 上載、張貼、公布或傳送任何誹謗、侮辱、具威脅性、攻擊性、不雅、猥褻、不實、違反公共秩序或善良風俗或其他不法之文字、圖片或任何形式的檔案於本服務上；
      <br>
      2. 侵害他人名譽、隱私權、營業秘密、商標權、著作權、專利權、其他智慧財產權及其他權利；
      <br>
      3. 違反依法律或契約所應負之保密義務；
      <br>
      4. 冒用他人名義使用本服務；
      <br>
      5. 上載、張貼、傳輸或散佈任何含有電腦病毒或任何對電腦軟、硬體產生中斷、破壞或限制功能之程式碼之資料；
      <br>
      6. 從事不法交易行為或張貼虛假不實、引人犯罪之訊息；
      <br>
      7. 濫發廣告郵件、垃圾郵件、連鎖信、違法之多層次傳銷訊息等；
      <br>
      8. 追蹤他人或其他干擾他人或為前述目的蒐集或儲存他人之個人資訊。
      <br>
      9. 其他本網站有正當理由認為不適當之行為。
      <br>
      <br>
      九、風險承擔會員了解並同意，使用本網站之各項服務係基於會員的個人意願，本網站不提供任何明示或默示的擔保，包含但不限於權利完整、商業適售性、特定目的之適用性及未侵害他人權利。本網站不保證以下事項，您須自行承擔相關風險：
      <br>
      1. 本網站將完全符合您的需求及期望。
      <br>
      2. 本網站或經由本網站而取得之結果為絕對即時、安全及正確。
      <br>
      3. 您經由本網站購買或取得之任何產品、服務、資訊或其他資料將符合您的期望。
      <br>
      4. 自本網站下載資料或圖片，或自本服務中獲得之資料導致會員的電腦系統損壞，或是發生任何資料流失等。
      <br>
      <br>
      十、服務之停止與更改
      <br>
      1. 於發生下列情形之一時，本網站有權停止或中斷提供服務；
      <br>
      2. 對本公司之電子通信設備進行必要之保養及施工時；
      <br>
      3. 發生突發性之電子通信設備故障時；
      <br>
      4. 由於本公司所申請之電子通信服務不問任何原因被停止，無法提供服務時；
      <br>
      5. 由於天災等不可抗力之因素致使本公司無法提供服務時；
      <br>
      6. 其他任何情形下本公司認為有必要時。
      <br>
      7. 會員瞭解並同意，本公司可能因公司、其他協力廠商或相關電信業者網路系統軟硬體設備之故障或失靈、或人為操作上之疏失而全部或一部中斷、暫時無法使用、遲延、或造成資料傳輸或儲存上之錯誤、或遭第三人侵入系統篡改或偽造變造資料等，會員不得因此而要求任何補償或賠償。
      <br>
      <br>
      十一、擔保責任免除您明確瞭解並同意：本網站對本服務不提供任何明示或默示的擔保，包含但不限於權利完整、商業適售性、特定目的之適用性及未侵害他人權利。本服務乃依其「現狀」及「提供使用時」之基礎提供，您使用本服務時，須自行承擔相關風險。
      <br>
      <br>
      本網站不保證以下事項：
      <br>
      (a). 本服務將符合您的需求
      <br>
      (b). 本服務不受惡意干擾、及時提供、安全可靠或無錯誤
      <br>
      (c). 由本服務之使用而取得之結果為正確或可靠
      <br>
      (d). 您經由本服務購買或取得之任何產品、服務、資訊或其他資料將符合您的期望。
      <br>
      您明確了解並同意本網站無須為您任何直接、間接、附隨、特別、衍生、懲罰性的損害負責，包括但不限於因下述事由所生利潤、商譽、使用、資料之損害或其他無形損失：
      <br>
      <br>
      (a). 使用或無法使用本服務
      <br>
      (b). 替代商品及服務之購買成本
      <br>
      (c). 他人未經授權存取或修改您的傳輸或資料
      <br>
      (d). 任何第三人就本服務所為之聲明或行為，或
      <br>
      (e). 任何其他與本服務有關者。
      <br>
      <br>
      十二、賠償責任限制
      <br>
      1. 您瞭解並同意，本公司對於會員使用各項服務、或無法使用各項服務所致生之任何直接、間接、衍生、或特別損害，免負任何賠償責任。若會員使用之服務係有對價者，本公司僅於會員所付之對價範圍內，負賠償責任。
      <br>
      2. 上述賠償責任限制，若依法為不得限制者，則限制規定將不予適用。
      <br>
      <br>
      十三、智慧財產權之尊重會員了解，必須充份尊重智慧財產權。本公司及本集團各關係企業及其所延伸之網站(含本網站)，於本網站上之所有著作及資料，其著作權、專利權、商標、營業秘密、其他智慧財產權、所有權或其他權利，均為本公司及本集團各該關係企業或其權利人所有，任何會員禁止發表侵害他人各項智慧財產權之文字、圖片或任何形式的檔案。除事先經本公司及本集團各該關係企業或權利人之合法授權外，會員不得擅自重製、傳輸、改作、編輯或以其他任何形式、基於任何目的加以使用，否則應負所有法律責任。
      <br>
      <br>
      十四、特別授權情形因使用本服務所提供之網路活動，可能須透過宅配或貨運業者始能完成貨品(或贈品等)之配送或取回，因此，會員同意並授權本網站得視該次網路交易或活動之需求及目的，將由會員所提供且為配送所必要之個人資料(如收件人姓名、配送地址、連絡電話等)，提供予宅配貨運業者及相關配合之廠商，以利完成該次貨品(或贈品等)之配送、取回。網站，並以集團經營之理念，會員於同意、接受本服務條款時，視為一併同意以本服務條款所規範之範圍，允許網站使用會員個人資料。
      <br>
      <br>
      十五、與第三方網站的連結若您無合法權利得授權他人使用、修改、重製、公開播送、改作、散布、發行、公開發表某資料，並將前述權利轉授權第三人，請勿擅自將該資料上載、傳送、輸入或提供予本網站。您所上載、傳送、輸入或提供予本網站之任何資料，其權利仍為您或您的授權人所有；
      但任何資料一經您上載、傳送、輸入或提供予本網站時，即表示您同意：
      1. 由本網站儲存或管理該資料，並由本網站公開刊登、使用於本網站的相關系統網路上，包括但不限於本網站合作的第三人網站上；
      <br>
      2. 授權本網站及其關係企業可以基於公益或為宣傳、推廣或經營本網  站及本服務之目的，進行使用、修改、重製、公開播送、改作、散布、發行、公開發表、公開傳輸、公開上映、翻譯該等資料，並得在此範圍內將前述權利轉授權他人。您並保證本網站及其關係企業使用、修改、重製、公開播送、改作、散布、發行、公開發表、公開傳輸、公開上映、翻譯、轉授權該等資料，不致侵害任何第三人之智慧財產權，否則應對本網站及其關係企業負損害賠償責任。
      <br>
      <br>
      十六、廣告、電子報及EDM發送您在本服務中瀏覽到的所有廣告內容、文字與圖片之說明、展示樣品或其他銷售資訊，均由各該廣告商、產品與服務的供應商所設計與提出。您對於廣告之正確性與可信度應自行斟酌與判斷。本網站僅接受委託予以刊登，不對前述廣告負擔保責任。會員同意本網站得不定期發送電子報或商品訊息(EDM)至會員所登錄的電子信箱帳號。當會員收到訊息後表示拒絕接受行銷時，本網站將停止繼續發送行銷訊息。
      <br>
      <br>
      十七、個別條款之效力本會員規範所定之任何條款之全部或一部無效時，不影響其他條款之效力。
      <br>
      <br>
      十八、停止或變更服務本網站保留於任何時點，不經通知隨時修改或暫時或永久停止繼續提供本服務（或其任一部分）的權利，且無需個別通知會員。您同意本網站所提供之服務範圍，本網站得視業務需要及實際情形，增減、變更或終止相關服務的項目或內容，且不另行個別通知，會員不得因此而要求任何補償或賠償。
      <br>
      <br>
      十九、損害賠償因會員違反相關法令或違背本會員規範之任一條款，致本網站及本集團任何關係企業、受僱人、受託人、代理人及其他相關履行輔助人因此而受有損害或支出費用（包括且不限於因進行民事、刑事及行政程序所支出之律師費用）時，會員應負擔損害賠償責任或填補其費用。
      <br>
      <br>
      二十、準據法及管轄法院會員了解，本會員規範之解釋及適用，以及會員因使用本服務而與本網站間及本集團間所生之權利義務關係如有不明確之處，應以本公司及本集團之認定及解釋為準。而若涉訟，應以中華民國法律為準據法，並同意以台灣台北地方法院為第一審管轄法院，但若法律對於管轄法院另有強制規定者，仍應依其規定。
      <br>
      <br>
      二十一、個人資料蒐集告知條款
      <br>
      1. 為客戶管理、會員管理及本集團各關係企業之業務行銷、資訊通訊管理、 網路購物及電子商務、內部的統計調查與分析及依法定義務進行個人資料之蒐集處理及利用等目的，本網站會員資料將與旺旺中時媒體集團(集團成員如http://www.chinatimes.com/customer/introduce 所載明之公司及其他關係企業)聯合收集資料，並共同遵守法令規定及嚴格要求內部同仁禁止私自使用資料。
      <br>
      當使用者於本網站輸入個人資料時，除如下列情形，或本網站另做特別聲明外，使用者的個人資料將只在本網站或聯合收集之集團成員利用。此外，如果資料係經由本網站連結，為第三方所蒐集或維護，本網站將會在資料蒐集或傳輸前取得使用者同意。
      <br>
      <br>
      2. 資料蒐集之目的：
      <br>
      蒐集之目的在於進行行銷業務、消費者、客戶管理與服務、網路購物及其他電子商務服務及與調查、統計與研究分析(法定特定目的項目編號為040、063、069、090、091、157)。本服務將藉由加入會員之過程或進行交易之過程進行個人資料蒐集。
      <br>
      <br>
      3. 蒐集之個人資料類別：
      <br>
      本服務於網站內蒐集的個人資料包括，
      <br>
      (a). C001 辨識個人者。例如：如會員之姓名、地址、電話、電子郵件等資訊。
      <br>
      (b). C011 個人描述。例如：性別、出生年月日等。
      <br>
      (c). C003 政府資料中之識別者。
      <br>
      例如：身分證統一編號、統一證號、稅籍編號、保險憑證號碼、殘障手冊號碼、退休證之號碼、證照號碼、護照號碼等。
      <br>
      (d). C011 個人描述。
      <br>例如：年齡、性別、出生年月日、出生地、國籍、聲音等。
      <br>
      (e). C014 個性。
      <br>例如：個性等之評述意見。
      <br>
      (f). C021 家庭情形。
      <br>
      例如：結婚有無、配偶或同居人之姓名、前配偶或同居人性名、結婚之日期、子女之人數等。
      <br>
      (g). C035 休閒活動及興趣。
      <br>例如：號碼、殘障手冊號碼、退休證之號碼、證照號碼、護照號碼等。
      <br>
      (h). C038 職業。
      <br>例如：學校校長、民意代表或其他各種職業。
      <br>
      (i). C051 學校記錄。
      <br>例如：大學、專科或其他學校等。
      <br>
      (j). C052 資格或技術。例如：學歷資格、專業技術、特別執照(如飛機駕駛執照等)、政府職訓機構學習過程、國家考試、考試成績或其他訓練紀錄等。
      <br>
      <br>
      4. 利用期間、地區、對象及方式：
      <br>
      (a). 期間：自同意加入會員至會員當事人要求停止使用或本服務停止提供服務之日為止。
      <br>
      (b). 地區：會員之個人資料將使用於台灣地區。
      <br>
      (c). 利用對象及方式：會員之個人資料蒐集除用於本服務之會員管理、客戶管理之檢索查詢等功能外，亦將利用於辨識身份、金流服務、物流服務、行銷廣宣等。
      <br>
      例示如下：以會員身份使用本網站提供之各項服務時，於頁面中自動顯示會員資訊。
      <br>
      為進行交易行為：會員對商品或勞務為預約、下標、購買、參與贈獎等之活動或從事其他交易時，關於商品配送、勞務提供、價金給付、回覆客戶之詢問、本服務對會員之詢問、相關售後服務及其他遂行交易所必要之業務。
      <br>
      宣傳廣告或行銷等：提供會員各種電子雜誌等資訊、透過電子郵件、郵件、電話等提供與服務有關之資訊。
      <br>
      將會員所瀏覽之內容或廣告，依客戶之個人屬性或購買紀錄、本網站之瀏覽紀錄等項目，進行個人化作業、會員使用服務之分析、新服務之開發或既有服務之改善等。
      <br>
      回覆客戶之詢問：針對會員透過電子郵件、郵件、、傳真、電話或其他任何直接間接連絡方式向本網站所提出之詢問進行回覆。
      <br>
      其他業務附隨之事項：附隨於上述各項之利用目的而為本網站提供服務所必要之使用。
      <br>
      <br>
      對於各別服務提供者之資訊提供：會員對服務提供者之商品或勞務為預約、下標、購買、參加贈獎活動或申請其他交易時，本網站於該交易所必要之範圍內，得將會員之個人資料檔案提供予服務提供者，並由服務提供者負責管理該個人資料檔案。
      本網站將以規約課予服務提供者依保障會員隱私權之原則處理個人資料之義務，但無法保證服務提供者會必然遵守，詳細內容需向各別服務提供者洽詢。
      <br>
      <br>
      5. 會員就個人資料之權利：本服務所蒐集個人資料之會員當事人，依個人資料保護法得對本網站主張行使以下權利：(a). 查詢或請求閱覽。
      <br>
      (b). 請求製給複製本。
      <br>
      (c). 請求補充或更正。
      <br>
      (d). 請求停止蒐集、處理或利用。
      <br>
      (e). 請求刪除。
      <br>
      <br>
      會員如欲行使上述權利，可與本網站客服service@ctwant.com  連絡進行申請。
      <br>
      <br>
      6. 對於會員所登錄或留存之個人資料，除下列情況外，本公司同意在未獲得會員同意以前，不對外揭露會員之姓名、地址、電子郵件及其他依受保護之個人資料：
      <br>
      (a). 基於法律之規定 ;
      <br>
      (b). 受司法機關或其他有權機關基於法定程序之要求 ;
      <br>
      (c). 為保障本公司之一切法益。
      <br>
      21.7. 在緊急情況下為維護其他會員或第三人之人身法益。
      <br>
      21.8. 代 Google 與 Facebook 告知事項：
      <br>
      <br>
      Google：
      本站所提供的部分服務（包括App以及網站），使用Google Analytics （分析）與 Google 廣告功能（以下稱 Google 服務），藉由 Google 服務蒐集並回傳給我們的數據資料，作為改善本報系服務品質及提供 Google 廣告用途。
      我們也會將這些數據資料（不含您的帳號或可直接識別您個人的資料）提供給我們的合作夥伴，共同改善本站服務。
      <br>
      ● Google 廣告：https://www.google.com/policies/technologies/ads/
      <br>
      ● Google 分析：https://support.google.com/analytics/answer/6004245?hl=zh-Hant
      <br>
      ● 最新最完整的內容，請參考以下連結：https://www.google.com.tw/intl/zh-TW/policies/privacy/
      <br>
      Facebook ：
      <br>
      我們承諾在取得您的同意後，我們才會蒐集您在臉書 ( Facebook ) 上的相關資料（包含您自己的資料或朋友資料），並在本站隱私權聲明及中華民國法令範圍內進行使用 （例如：我們或我們的合作夥伴提供您可能有興趣的廣告內容）。
      <br>
      <br>
      二十二、終止或拒絕會員使用您同意本網站得依其判斷因任何理由，包含但不限於一定期間未使用、法院或政府機關命令、本服務無法繼續或服務內容實質變更、無法預期之技術或安全因素或問題、您所為詐欺或違法行為、未依約支付費用，或其他本網站認為您已經違反本服務條款的明文規定及精神，而終止或限制您使用帳號（或其任何部分）或本服務之使用，並將本服務內任何「會員內容」加以移除並刪除。
      您並同意前開終止或限制，本網站得立即關閉、刪除或限制存取您的帳號及您帳號中全部或部分相關資料及檔案，及停止本服務全部或部分之使用。
      <br>
      此外，您同意若本服務之使用被終止或限制時，本網站對您或任何第三人均不承擔責任。
      <br>
      <br>
      二十三、本條款暨權利聲明自即日起生效
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      pageTitle: '隱私權政策 | CTWANT'
    }
  },
  head() {
    const hostAndNeedBackslashPath = this.HOST + (this.$route.path.substr(this.$route.path.length - 1) === '/' ? this.$route.path : `${this.$route.path}/`)
    return {
      title: this.pageTitle,
      meta: [
        { hid: 'ogUrl', property: 'og:url', content: hostAndNeedBackslashPath },
        { hid: 'ogTitle', property: 'og:title', content: this.pageTitle }
      ],
      link: [
        { hid: 'alternate', rel: 'alternate', hreflang: 'zh-Hant', href: hostAndNeedBackslashPath },
        { hid: 'canonical', rel: 'canonical', href: hostAndNeedBackslashPath }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'HOST'
    ])
  },
  mounted() {
    this.$nextTick(() => {
      this.$store.dispatch('ad/displayAd')
      this.$store.dispatch('ad/registerAndDisplayPopupAd', { isHideAd: 'Y' })
      this.$gtm.push({
        event: 'domMounted',
        pageUrl: this.$route.fullPath,
        pageTitle: this.pageTitle
      })
    })
  }
}
</script>

<style lang="scss" scoped>
@import '~/assets/scss/pages/_privacy';
</style>
